export default __webpack_public_path__ + "static/media/nyskyline.f6f16685.jpeg";